"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdleState = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_pointer_event_type_1 = require("../internal-events/e-pointer-event-type");
const e_mouse_event_type_1 = require("../internal-events/e-mouse-event-type");
const e_pointer_event_button_1 = require("../internal-events/e-pointer-event-button");
/**
 * @public
 * The initial state of the default user interaction state machine.
 */
class IdleState {
    constructor(lastClick, options, providers, sharedState) {
        this.lastClick = lastClick;
        this.options = options;
        this.providers = providers;
        this.sharedState = sharedState;
        if (this.lastClick != null && this.options.doubleClickOptions != null) {
            setTimeout(() => this.lastClick = null, this.options.doubleClickOptions.timeout);
        }
    }
    handleMouseEvent(eventType, chartEvent) {
        switch (eventType) {
            case e_mouse_event_type_1.EMouseEventType.Wheel:
                {
                    this.providers.callbacks.onWheel(chartEvent, -chartEvent.$event.deltaY);
                    return null;
                }
        }
        return rc_js_util_1._Production.assertValueIsNever(eventType);
    }
    handlePointerEvent(eventType, chartEvent) {
        switch (eventType) {
            case e_pointer_event_type_1.EPointerEventType.Down:
                {
                    if (chartEvent.$event.button === e_pointer_event_button_1.EPointerEventButton.LeftMouse) {
                        const targets = this.providers.eventTargets.dragTargetProvider.hitTestPlot(chartEvent);
                        if (targets.length > 0) {
                            this.sharedState.dragTargets = this.providers.callbacks.onDragStart(targets, chartEvent)
                                ? targets.filter(target => { var _a, _b; return (_b = (_a = target.entity).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, chartEvent, target.segmentIds); })
                                : null;
                            if (this.sharedState.dragTargets != null) {
                                return this.providers.stateFactories.getDraggingState(chartEvent, this.options, this.providers, this.sharedState);
                            }
                        }
                        // fall through intentional
                        return this.providers.stateFactories.getIndeterminateState(chartEvent, this.options, this.providers, this.sharedState, this.lastClick);
                    }
                    else if (chartEvent.$event.button === e_pointer_event_button_1.EPointerEventButton.RightMouse) {
                        // right click, no need to go via indeterminate
                        this.sharedState.onClick(chartEvent);
                        return null;
                    }
                    else {
                        return null;
                    }
                }
            case e_pointer_event_type_1.EPointerEventType.Move:
                {
                    this.sharedState.onHover(chartEvent);
                    return null;
                }
            case e_pointer_event_type_1.EPointerEventType.Out:
            case e_pointer_event_type_1.EPointerEventType.Up:
                this.sharedState.clearAllHoveredEntities(chartEvent);
                return null;
        }
        return rc_js_util_1._Production.assertValueIsNever(eventType);
    }
}
exports.IdleState = IdleState;
//# sourceMappingURL=idle-state.js.map